// extracted by mini-css-extract-plugin
module.exports = {"mobileOnly":"B5lf","column":"B5lh","verticalTile":"B5hv","smallTile":"B5lj","headerLink":"B5kx","header":"B5ap","list":"B5ar","listItem":"B5ll","middle":"B5ln"};